import {
    RequestOptions, isMessageError, IHttp, Http, HttpClient as FHttpClient
} from "@firefly/fly-http";
import {ClientOptions} from "./typing";
import {SecurityClient} from "../core";
import {AccessDeniedExceptions, AuthenticationExceptions} from "./exception";


export interface HttpClientOptions<TPrincipal> extends ClientOptions {
    securityClient: SecurityClient<TPrincipal>;
}

export class HttpClient<TPrincipal = unknown> {
    securityClient: SecurityClient<TPrincipal>;
    http: IHttp;
    constructor(options: HttpClientOptions<TPrincipal>) {
        const {
            securityClient,
            handler,
        } = options;
        this.securityClient = securityClient;
        this.http = new Http(new FHttpClient(handler));
    }

    private async wrap<T>(promise: Promise<T>): Promise<T> {
        return promise.catch((reason) => {
            if (isMessageError(reason)) {
                const error = reason.errorInfo;
                const {
                    code,
                } = error;
                switch (code) {
                    case "ACCESS_DENIED": {
                        if (!this.securityClient.isAuthenticated()) {
                            throw AuthenticationExceptions.fullAuthenticationIsRequired(reason);
                        }
                        break;
                    }
                    case "UNAUTHENTICATED":
                    case "INSUFFICIENT_AUTHENTICATION": {
                        throw AuthenticationExceptions.insufficientAuthenticationException(error);
                    }
                    case "FORBIDDEN": {
                        throw AccessDeniedExceptions.accessDenied(code, error);
                    }
                }
            }
            throw reason
            // throw reason;
        })
    }
    public get(url: string, params?: any, options: RequestOptions = {}): Promise<any> {
        return this.wrap(this.http.get(url, params, options));
    }
    public post(url: string, body?: any, options: RequestOptions = {}): Promise<any> {
        return this.wrap(this.http.post(url, body, options));
    }
    public patch(url: string, body?: any, options: RequestOptions = {}): Promise<any> {
        return this.wrap(this.http.patch(url, body, options));
    }
    public put(url: string, body?: any, options: RequestOptions= {}): Promise<any> {
        return this.wrap(this.http.put(url, body, options));
    }
    public delete(url: string, params?: any, options: RequestOptions = {}): Promise<any> {
        return this.wrap(this.http.delete(url, params, options));
    }
}